export const searchbarPlaceholder = 'Ask';
